import React, { useEffect, useState } from "react";
import { ensureBarCode, linkFor, qrFor, signupCount, CONTEST_END, CONTEST_PRIZE } from "./referrals";

// Owner's "get your customers on the app" card: the bar's own QR code and
// link, how many customers it has signed up, and the contest.
export default function SignupLinkCard({ bar }) {
  const [qr, setQr] = useState("");
  const [count, setCount] = useState(null);
  const [copied, setCopied] = useState(false);
  const [code, setCode] = useState("");

  // Gets (and the first time, locks in) this bar's permanent code.
  useEffect(() => {
    if (!bar) return;
    let cancelled = false;
    setQr("");
    setCount(null);
    ensureBarCode(bar)
      .then((c) => {
        if (cancelled) return;
        setCode(c);
        qrFor(c).then((url) => !cancelled && setQr(url)).catch(() => {});
        signupCount(c).then((n) => !cancelled && setCount(n)).catch(() => {});
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [bar?.id, bar?.referralCode]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!bar) return null;
  const link = code ? linkFor(code) : "";
  const daysLeft = Math.ceil((CONTEST_END - new Date()) / 86400000);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.prompt("Copy this link:", link);
    }
  };

  return (
    <section style={{ background: "#1E1428", border: "2px solid #FF3D81", borderRadius: "16px", padding: "20px", display: "flex", flexWrap: "wrap", gap: "20px", alignItems: "center" }}>
      <div style={{ flex: "0 0 auto", background: "#fff", borderRadius: "12px", padding: "8px", width: "164px", height: "164px", display: "flex", alignItems: "center", justifyContent: "center" }}>
        {qr ? <img src={qr} alt={`QR code that signs customers up for ${bar.name}`} style={{ width: "148px", height: "148px" }} /> : <span style={{ color: "#555" }}>…</span>}
      </div>
      <div style={{ flex: "1 1 300px", minWidth: 0, display: "flex", flexDirection: "column", gap: "8px" }}>
        <h2 style={{ margin: 0, fontSize: "20px" }}>Get your customers on Bar Fun Finder</h2>
        <p style={{ margin: 0, color: "#D6D2E4", fontSize: "15px", lineHeight: 1.5 }}>
          Print this QR code for tables, the bar top and bathroom mirrors, or share the link on your socials.
          Everyone who signs up with it counts for {bar.name}.
        </p>
        <p style={{ margin: 0, fontSize: "16px" }}>
          <strong style={{ fontSize: "26px", color: "#FF6FA3" }}>{count ?? "–"}</strong>{" "}
          customers signed up with your code
        </p>
        {daysLeft > 0 && (
          <p style={{ margin: 0, fontSize: "15px", color: "#FFD27A" }}>
            Contest: the bar with the most sign-ups by Dec 1 wins {CONTEST_PRIZE}. {daysLeft} {daysLeft === 1 ? "day" : "days"} left.
          </p>
        )}
        <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "4px" }}>
          {qr && (
            <a href={qr} download={`${code}-qr.png`} style={{ minHeight: "44px", display: "inline-flex", alignItems: "center", padding: "0 16px", borderRadius: "10px", background: "#FF3D81", color: "#0B0B12", fontWeight: 700, textDecoration: "none" }}>
              Download QR code
            </a>
          )}
          <button type="button" onClick={copy} disabled={!link} style={{ minHeight: "44px", padding: "0 16px", borderRadius: "10px", border: "1px solid #3A3350", background: "transparent", color: "#fff", fontWeight: 600, cursor: "pointer" }}>
            {copied ? "Copied!" : "Copy link"}
          </button>
        </div>
        {link && <code style={{ fontSize: "13px", color: "#ACA8BF", wordBreak: "break-all" }}>{link}</code>}
      </div>
    </section>
  );
}
